import React from "react";
import styles from "./Button.module.css";

type ButtonVariant = "primary" | "secondary" | "outline" | "ghost" | "contact";
type ButtonSize = "sm" | "md" | "lg";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  variant?: ButtonVariant;
  size?: ButtonSize;
}

const Button: React.FC<ButtonProps> = ({
  children,
  className = "",
  variant = "primary",
  size = "md",
  ...props
}) => {
  let buttonClasses = [styles.button];

  if (variant && variant !== "contact" && styles[variant as keyof typeof styles]) {
    buttonClasses.push(styles[variant]);
  }

  // Añade la clase del tamaño si existe en styles
  if (size && styles[size]) {
    buttonClasses.push(styles[size]);
  }

  // Añade cualquier clase adicional pasada como prop
  if (className) {
    buttonClasses.push(className);
  }

  return (
    <button
      // Une todas las clases con un espacio y elimina espacios extra
      className={buttonClasses.join(" ").trim()}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
